<template>
	<popup class="delete-popup" title="Are you sure?" @close="close" >
		<template v-slot:content>
			<div class="layout-column flex">
				<p style="font-weight: bold">Are you sure you want to permanently delete this popup
					<b>[{{popup.name}}]</b> ?
				</p>
				<p style="color: red">Once deleted a popup won't be accessible from any of your pages.</p>
			</div>
		</template>
		<template v-slot:actions>
			<v-button label="Delete popup" :loading="loading" border red @click="deletePopup" />
			<v-button label="Cancel" border @click="close" />
		</template>
	</popup>
</template>

<script>
import Popup from '@/components/base/popup';
import VButton from '@/components/base/v-button';
import VSwitch from '@/components/base/v-switch';
import InputField from '@/components/base/input-field';
import VSpinner from '@/components/base/v-spinner';
import {mapGetters} from "vuex";
import API from '@/api';
import {getPriceBrief} from '@/helpers/products';
import {types} from "@/helpers/stepTypes";

export default {
	name: "delete-popup",
	components: {Popup, VButton,},
	props:['popup'],
	mixins:[API],
	data() {
		return {
			loading: false,
		}
	},
	computed:{
		...mapGetters(['page_findAll', 'current_popup']),
		stepId(){
			return this.$store.state.page.initial ? this.$store.state.page.initial.step : '';
		},
		funnelId(){
			return this.$store.state.page.initial ? this.$store.state.page.initial.funnel : '';
		},
		isOTO() {
			if (!this.step) return false;
			return this.step.type===types.UPSELL||this.step.type===types.DOWNSELL;
		}
	},
	methods: {
		close() {
			this.$emit('close');
		},
		async deletePopup() {
			try {
				this.loading = true;

				let res = await this.api.popups.delete(this.popup.id);
				if (res && res.error) {
					throw res
				}
				if (this.current_popup && this.current_popup.id===this.popup.id) {
					this.$store.commit('PAGE_SET_TAB', null) // to prevent undefined in props.
					this.$store.commit('PAGE_SET_POPUP', null)
				}
				this.$info("Popup deleted successfully!");
				this.$emit('done', this.popup);
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		}
	},
	created() {
	}
}
</script>

<style lang="scss" >
.cta-popup.section-tag {
	opacity: 0.7;
	//color: silver;
}
.delete-popup {
	.popup {
		max-width: 550px;
	}
	.content {
		//padding: 0;
		p {
			margin-block-start: 5px;
			margin-block-end: 5px;
		}
	}
	.popup_header {
		margin: 0;
	}
}
</style>
